export default function WhatsAppBenefits() {
  const benefits = [
    {
      icon: 'ri-video-line',
      title: 'Diagnostic Vidéo Instantané',
      description: 'Envoyez-nous une vidéo de votre problème via WhatsApp. Notre expert analyse immédiatement et vous donne un premier diagnostic.'
    },
    {
      icon: 'ri-time-line',
      title: 'Réponse Rapide Garantie',
      description: 'Réponse sous 2h en journée. Pas d\'attente téléphonique, pas de formulaire complexe. Communication directe et efficace.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Estimation Immédiate',
      description: 'Recevez une fourchette de prix précise avant toute intervention. Transparence totale sur les coûts.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Prise de RDV Simplifiée',
      description: 'Planifiez votre intervention directement par chat. Confirmation instantanée avec rappel automatique.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-green-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-whatsapp-fill mr-2"></i>
            Service WhatsApp Premium
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Diagnostic Vidéo WhatsApp : Rapide & Efficace
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Gagnez du temps avec notre service de diagnostic par vidéo WhatsApp. 
            Une solution moderne pour une réactivité maximale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all">
              <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-lg mb-4">
                <i className={`${benefit.icon} text-3xl text-green-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Card */}
        <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-whatsapp-fill text-5xl"></i>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Prêt à Résoudre Votre Problème de Châssis ?
            </h3>
            <p className="text-lg mb-8 opacity-90">
              Contactez-nous maintenant sur WhatsApp pour un diagnostic vidéo gratuit
            </p>
            <a
              href="https://wa.me/32475585219"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-white text-green-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl mr-3"></i>
              Prendre RDV pour un diagnostic
            </a>
            <p className="text-sm mt-6 opacity-75">
              <i className="ri-time-line mr-2"></i>
              Disponible 7j/7 - Réponse sous 2h en journée
            </p>
          </div>
        </div>

        {/* How it works */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Comment ça marche ?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4 text-xl font-bold text-green-600">
                1
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Filmez le problème</h4>
              <p className="text-sm text-gray-600">Prenez une courte vidéo du châssis défectueux</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4 text-xl font-bold text-green-600">
                2
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Envoyez sur WhatsApp</h4>
              <p className="text-sm text-gray-600">Transmettez la vidéo au +32475585219</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4 text-xl font-bold text-green-600">
                3
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Recevez le diagnostic</h4>
              <p className="text-sm text-gray-600">Notre expert analyse et vous répond rapidement</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4 text-xl font-bold text-green-600">
                4
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Planifiez l'intervention</h4>
              <p className="text-sm text-gray-600">Confirmez le RDV directement par chat</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}